<template>
    <div>
      <table class="table table-hover" v-bind:id="id"  width="100%">
        <thead>
        </thead>
        <tbody>
        </tbody>             
      </table>
    </div>
  </template>
  <script>
    export default {
      name:"TableSample",
      props: {id:'',data_:[],lengthMenu:[],columns:[],},
      mounted () {
        //TableManaged2.init2();
        this.createTable();
        window.tableBitacora = this;
      },      
      methods:{
        detalleRegistros(dato){
          this.$emit('guardar', dato);
        },
        createTable(){
          $('#' + this.id).DataTable( {
            "data": this.data_,
            "columns": this.columns,
            "pageLength": 5,
            "autoWidth": false,
            "lengthMenu": [
                [5, 15, 20,50,100, -1],
                [5, 15, 20,50,100, "All"] // change per page values here
            ],
          });
        },
      }        
    }
  </script>